import React  from 'react';
import PageDefault from '../../../components/PageDefault';

function CadastroCategoria(){
 return (
        <PageDefault>
            <h1>Indisponível</h1>
        </PageDefault>
 )   
}

export default CadastroCategoria;
